import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import get from 'lodash-es/get';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-configurator-error',
    templateUrl: './configurator-error.component.html',
    styleUrls: ['./configurator-error.component.scss'],
    standalone: false,
})
export class ConfiguratorErrorComponent extends Toast {
    isBrowser: boolean;

    constructor(
        protected toastrService: ToastrService,
        public toastPackage: ToastPackage,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        super(toastrService, toastPackage);
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    isNarrow() {
        if (!this.isBrowser) {
            return false;
        }
        return window.innerWidth >= 1100 ? false : true;
    }

    jumpToCategory() {
        const category = get(this.toastPackage, 'toastRef.componentInstance.category');
        if (this.isBrowser) {
            const el = document.getElementById('scroll-div') ? document.getElementById('scroll-div') : document.getElementsByTagName('html').item(0);
            const section = document.getElementById(category);
            const offset = this.isNarrow() ? 0 : 150;
            el.scrollTo({
                top: section.offsetTop - offset,
                behavior: 'smooth',
            });
        }
    }
}
